import { apiClient } from './apiMonitoring';
import { API_BASE_URL } from './apiConfig';

export async function addClinic({ token, data }) {
  return apiClient.post('/api/clinics', data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function fetchClinics({ token }) {
  return apiClient.get('/api/clinics', {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export async function addBranchToTenant({ token, tenantId, data }) {
  return apiClient.post(`/api/tenants/${tenantId}/branches`, data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function deleteBranchFromTenant({ token, tenantId, branchId }) {
  return apiClient.delete(`/api/tenants/${tenantId}/branches/${branchId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export async function patchBranchForTenant({ token, tenantId, branchId, data }) {
  return apiClient.patch(`/api/tenants/${tenantId}/branches/${branchId}`, data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function fetchSuperAdmins({ token }) {
  return apiClient.get('/api/super-admins/', {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export async function demoteSuperAdmin({ token, userId, branchId }) {
  return apiClient.post(`/api/super-admins/demote/${userId}?branch_id=${branchId}`, null, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
} 

// New clinic settings API functions
export async function getClinicDetails({ token, clinicId }) {
  return apiClient.get(`/api/clinics/${clinicId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export async function updateClinicInfo({ token, clinicId, data }) {
  return apiClient.patch(`/api/clinics/${clinicId}`, data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function updateClinicBranding({ token, clinicId, data }) {
  return apiClient.patch(`/api/clinics/${clinicId}/branding`, data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function fetchClinicBranding(clinicId, token) {
  return apiClient.get(`/api/clinics/${clinicId}/branding`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export async function uploadClinicLogo(clinicId, file, token) {
  const formData = new FormData();
  formData.append('file', file);
  
  // Use apiFetch for automatic CSRF token handling
  const { apiFetch } = await import('./apiFetch');
  
  return apiFetch(`/api/clinics/${clinicId}/upload-logo`, {
    method: 'POST',
    headers: { 
      'Authorization': `Bearer ${token}`,
      // Don't set Content-Type, let the browser set it with boundary for FormData
    },
    body: formData,
  });
}

export async function deleteClinicLogo(clinicId, token) {
  // Use apiClient for automatic CSRF token handling
  return apiClient.delete(`/api/clinics/${clinicId}/logo`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

// Staff Profile Picture Management
export async function uploadStaffProfilePicture(token, staffId, file) {
  const formData = new FormData();
  formData.append('file', file);
  
  // Use apiClient for automatic CSRF token handling
  return apiClient.post(`/api/staff/${staffId}/profile-picture`, formData, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      // Don't set Content-Type, let the browser set it with boundary for FormData
    }
  });
}

export async function getStaffProfilePicture(token, staffId) {
  // Use apiClient for automatic CSRF token handling (GET doesn't need CSRF, but for consistency)
  return apiClient.get(`/api/staff/${staffId}/profile-picture`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
    }
  });
}

export async function deleteStaffProfilePicture(token, staffId) {
  // Use apiClient for automatic CSRF token handling
  return apiClient.delete(`/api/staff/${staffId}/profile-picture`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
    }
  });
}

export async function updateUserProfile({ token, data }) {
  return apiClient.patch('/api/users/profile', data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function changeUserPassword({ token, data }) {
  return apiClient.post('/api/users/change-password', data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function updateSecuritySettings({ token, data }) {
  return apiClient.patch('/api/users/security', data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export async function updateNotificationSettings({ token, data }) {
  return apiClient.patch('/api/users/notifications', data, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
} 